import React from 'react'
import PropTypes from 'prop-types'
import DOMpurify from 'isomorphic-dompurify'

import { StyledIcon } from './Icon.styled'

const Icon = (props) => {
  const { absolutePath, alt, children, color, height, svg, size, type, width } =
    props

  const isSvg = svg?.length !== 0

  const sanitizer = DOMpurify.sanitize
  if (svg && svg.content) {
    // Inlined SVGs
    return (
      <StyledIcon
        dangerouslySetInnerHTML={{ __html: sanitizer(svg.content) }}
        $isSvg={isSvg}
        $height={height}
        $size={size}
        $svgColor={color}
        $type={type}
        $width={width}
      />
    )
  }
  // SVGs that can/should not be inlined
  return (
    <StyledIcon
      $isSvg={isSvg}
      $height={height}
      $size={size}
      $svgColor={color}
      $type={type}
      $width={width}
    >
      {children || <img src={absolutePath} alt={alt} />}
    </StyledIcon>
  )
}

Icon.propTypes = {
  absolutePath: PropTypes.string,
  alt: PropTypes.string,
  color: PropTypes.string,
  children: PropTypes.any,
  height: PropTypes.string,
  size: PropTypes.string,
  svg: PropTypes.any,
  type: PropTypes.string,
  width: PropTypes.string,
}

export default Icon
